enum DefinedContributionType {
  IPI = 'IPI',
  IPIP = 'IPIP',
  PKKI = 'PKKI',
  PKKL = 'PKKL',
  INNSKUDDSPENSJONFLEX = 'INNSKUDDSPENSJON_FLEX',
  UNDEFINED = 'UNDEFINED',
}

export default DefinedContributionType;
